var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bracket-container w-100 h-100"},[(_vm.tournmaentLoaded && _vm.bracketStructure)?_c('EliminationBracket'):_c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100 my-5 mx-auto"},[_c('h5',{staticClass:"font-weight-bold av-soon-text"},[_vm._v("Bracket sera bientôt disponible !")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }